import ScheduleValidator from '@/vue/components/pages/dynamic-ess/validators/schedule-validator.js';

export default class BatteryRestrictionsValidator extends ScheduleValidator {
    validateRows(rows) {
        const hasMinimumOneEnabled = rows.some(row => row[this.valueField].value);

        if (hasMinimumOneEnabled) {
            return;
        }

        this.hasError = true;
        this.errorMessage = 'ess.error_minimum_enabled_restrictions';
    }
}
